﻿import * as Model from '../../models/models';

export class EventLogViewModel {
    public searchResults: Array<Model.IEventLog>;
    public severityOptions: Array<string>;
    public applicationOptions: Array<string>;
    public loggerOptions: Array<string>;
    public recordCount: number;
}

export class SearchResultModel {
    submissionId: string;
}
